<template>
    <div class="panel-content">
        <h2>Stichting Voorbereiding Pallas-reactor</h2>
        <a @click="trackLink" class="button" href="https://pallasreactor.com" target="_blank">Ga naar de site!</a>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {
        methods: {
            trackLink()
            {
                window.dataLayer.push({ 'event': 'clickout', 'url': 'https://pallasreactor.com' });
            }
        }
    };
</script>
